import WAValidator from "multicoin-address-validator";

const cryptoWalletsRegex = {
  NEO: { NEO: /^N[0-9A-Za-z]{33}$/ },
  XEM: { XEM: /^(NA|NB|NC|ND)[A-Za-z0-9]{38}$/ },
  AVAX: { XCHAIN: /^(X-avax)[0-9A-Za-z]{39}$/ },
};

const validateCryptoWallet = (asset, wallet, network) => {
  if (cryptoWalletsRegex?.[asset]?.[network]?.test(wallet)) {
    return true;
  }

  if (
    asset === "TON" ||
    (asset === "USDT" && network === "TON") ||
    asset === "CATI" ||
    asset === "DOGS" ||
    asset === "ENA" ||
    asset === "NOT" ||
    asset === "WIF"
  ) {
    return /^([EUkK0])[A-Za-z0-9_-]{47}$/.test(wallet);
  }

  let WAValidator = require("multicoin-address-validator");
  let WAValidator2 = require("@swyftx/api-crypto-address-validator");

  if (asset === "USDT" && network === "ERC20") asset = "ETH";
  if (asset === "USDT" && network === "OMNI") asset = "BTC";
  if (asset === "USDT" && network === "TRC20") asset = "TRX";
  if (asset === "USDT" && network === "SOL") asset = "SOL";
  if (asset === "USDT" && network === "ARBITRUM") asset = "ARB";
  if (asset === "USDC" && network === "TRC20") asset = "TRX";
  if (asset === "USDC" && network === "ERC20") asset = "ETH";
  // if (asset === "BNB" && network === 'BEP2') asset = "BNB";
  if (asset === "BNB" && network === "BEP20") asset = "ETH";
  if (asset === "MATIC" && network === "POLYGON") asset = "ETH";
  if (asset === "MATIC" && network === "ERC20") asset = "ETH";
  if (asset === "GALA" && network === "GALA") asset = "ETH";
  if (asset === "AVAX" && network === "CCHAIN") asset = "ETH";
  if (asset === "SAND" && network === "SAND") asset = "ETH";
  if (asset === "AXS" && network === "AXS") asset = "ETH";
  if (asset === "BTT" && network === "BTT") asset = "TRX";
  if (asset === "1INCH" && network === "1INCH") asset = "ETH";

  try {
    return WAValidator.validate(wallet, asset);
  } catch (e) {
    try {
      return WAValidator2.validate(wallet, asset);
    } catch (e) {
      return true;
    }
  }
};

const validateCardNumber = (cardNo) => {
  let s = 0;
  let doubleDigit = false;
  for (let i = cardNo.length - 1; i >= 0; i--) {
    let digit = +cardNo[i];
    if (doubleDigit) {
      digit *= 2;
      if (digit > 9)
        digit -= 9;
    }
    s += digit;
    doubleDigit = !doubleDigit;
  }
  return s % 10 === 0;

};

export {
  validateCryptoWallet,
  validateCardNumber
};
